import { isValidEmail } from '@lib/shared/utils/is-valid-email';
import { z } from 'zod';

const DEFAULT_MESSAGE = 'Enter a valid email address';

/**
 * Zod email that also requires a real top-level domain.
 *
 * Drop-in for `z.email()` / `z.string().email()` so typo TLDs such as
 * `gmail.comi` fail at the schema boundary instead of later (Clerk, SMTP).
 */
export function validEmail(message: string = DEFAULT_MESSAGE) {
  return z.email({ error: message }).refine(isValidEmail, { message });
}

/** Email string that passes Zod syntax and a real-TLD check. */
export const validEmailSchema = validEmail();

/** Optional email (undefined allowed; empty string rejected). */
export const optionalValidEmailSchema = validEmailSchema.optional();
